// Ochiq ariza sahifasi /apply, en — manba
export default {
  brand: "Driver jobs",
  closedTitle: "Applications are closed right now.",
  closedDesc: "Please check back later.",
  h1: "Apply for a CDL-A truck driver job",
  lead: "Takes 1 minute. A recruiter will call you.",
  fullName: "Full name",
  phone: "Phone",
  email: "Email",
  state: "State",
  statePlaceholder: "State",
  cdlClass: "CDL class",
  classPlaceholder: "Class",
  classA: "Class A",
  classB: "Class B",
  classC: "Class C",
  experience: "Driving experience",
  choose: "Choose",
  exp: { lt1: "Less than 1 year", y1_2: "1–2 years", y2_5: "2–5 years", y5: "5+ years" },
  equipment: "Equipment you want to drive",
  website: "Website",
  consent: "I agree to be contacted by phone, text and email about driving jobs. Consent is not a condition of employment. Msg & data rates may apply.",
  submit: "Submit application",
  noSsn: "We never ask for your SSN on this form.",
  sendFailed: "Could not send the application. Check your connection and try again.",
  errors: {
    name: "Enter your full name",
    nameTwo: "Enter your first and last name",
    phone: "Enter a valid US phone number",
    email: "Enter a valid email",
    state: "Choose your state",
    cdl: "Choose your CDL class",
    experience: "Choose your experience",
    consent: "Consent is required",
  },
  thanks: "Thanks, {{name}}!",
  thanksAnon: "Thanks!",
  received: "Your application was received. A recruiter will call you within 1 business day.",
  questions: "Questions? Reply to the recruiter's call.",
  back: "Back to {{company}}",
};
